import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const BedanktScreen = () => {
  const navigate = useNavigate();

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
      <Card className="text-center p-5 shadow-lg">
        <h1 className="mb-4">🎉 Bedankt voor je inzending! 🎉</h1>
        
        <p className="fs-5">
          📩 Het <strong>gratis verzendlabel</strong> is aangemaakt en naar je e-mailadres gestuurd.
          <br />
          📬 <strong>Controleer je inbox en eventueel je spam- of ongewenste-e-mailmap.</strong>
        </p>

        <h3 className="mt-4">📦 Volgende stappen:</h3>
        <ul className="text-start fs-5">
          <li>📌 <strong>Verpak de boeken stevig.</strong></li>
          <li>🚚 <strong>Breng het pakket naar een DHL-punt bij jou in de buurt.</strong></li>
          <li>📱 <strong>Laat de barcode op het verzendlabel zien.</strong></li>
        </ul>

        <p className="fs-5">
          ✅ Nadat we je zending hebben bevestigd, ontvang je een e-mail en krijg je betaald! 💰
        </p>

        <Button variant="primary" size="lg" className="mt-3" onClick={() => navigate("/verkoop")}>
          Nog meer verkopen
        </Button>
      </Card>
    </Container>
  );
};

export default BedanktScreen;
